import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlSegmentGroup } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TableRouteService {
  private readonly storageKey = 'tableToken';

  constructor(private router: Router) {}

  getTableToken(): string {
    const tokenFromUrl = this.readTokenFromUrl(this.router.url);

    if (tokenFromUrl) {
      localStorage.setItem(this.storageKey, tokenFromUrl);
      return tokenFromUrl;
    }

    return localStorage.getItem(this.storageKey) || '';
  }

  getTableTokenFromUrl(): string {
    return this.readTokenFromUrl(this.router.url);
  }

  buildCommands(path: string | string[]): string[] {
    const tableToken = this.getTableToken();
    const segments = Array.isArray(path) ? path : [path];
    const normalizedSegments = segments
      .filter(segment => segment !== undefined && segment !== null)
      .map(segment => String(segment).replace(/^\/+|\/+$/g, ''))
      .filter(Boolean);

    return tableToken ? [tableToken, ...normalizedSegments] : normalizedSegments;
  }

  buildUrl(path: string | string[]) {
    return `/${this.buildCommands(path).join('/')}`;
  }

  navigate(path: string | string[], extras?: NavigationExtras) {
    return this.router.navigate(this.buildCommands(path), extras);
  }

  navigateByUrl(path: string) {
    const commands = this.buildCommands(path);
    return this.router.navigate(commands);
  }

  private readTokenFromUrl(url: string): string {
    const tree = this.router.parseUrl(url || '/');
    const primary: UrlSegmentGroup | undefined = tree.root.children.primary;
    const segments = primary?.segments ?? [];

    if (segments.length < 2) {
      return '';
    }

    return segments[0]?.path || '';
  }
}
